import YourAccountBase from "../../views/yourAccount/YourAccountBase";

export default [
  {
    path: "/ya/:customerId",
    name: "ya",
    component: YourAccountBase,
    meta: { requiresAuth: true }
  },
  {
    path: "/ya",
    redirect: {
      name: "signin"
    }
  }
];
